module.exports = __webpack_public_path__ + "d52837877d4721bd48a15c91de15e6e2.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Light-Oblique.woff
// module id = 378
// module chunks = 0